import { createTranslations } from '@npco/utils-translations'

export const accountStatementWarningTranslations = createTranslations({
  message: 'Account Statements are generated in UTC+10 time.',
})
